import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { PlantillaService } from './plantillas.service';
import { PlantillaTranslations, plantillaTranslations } from './translations-plantillas';
import { getCurrentLanguage } from '../core/helpers/utils';

// services
import { EventService } from 'src/app/core/service/event.service';

// constants
import { EventType } from 'src/app/core/constants/events';

// types
import { SortEvent } from 'src/app/shared/advanced-table/sortable.directive';
import { Column } from 'src/app/shared/advanced-table/advanced-table.component';
import { Plantilla } from './plantillas.model';

@Component({
  selector: 'app-list-plantillas',
  templateUrl: './list-plantillas.component.html',
  styleUrls: ['./list-plantillas.component.scss']
})
export class ListPlantillasComponent implements OnInit, AfterViewInit {

  constructor(
    private eventService: EventService,
    private router: Router,
    private elRef: ElementRef,
    private plantillasService: PlantillaService
    ) { }

  records: Plantilla[] = [];
  columns: Column[] = [];
  pageSizeOptions: number[] = [10, 25, 50, 100];

  // Botón de acción de la tabla
  currentLanguage: string = getCurrentLanguage()
  buttonTitle: string = '';
  buttonLink: string = 'plantillas/new';

  // Control de loading de la tabla cuando los usuarios hayan sido recibidos desde el backend
  loaded: boolean = false;

  // Control de errores
  error: string = '';

  // Animación de loading
  loading: boolean = false;

  // Para controlar las búsquedas
  allDatasearch: Plantilla[] = []

  showConfirmDeleteModal: boolean = false;
  plantillaToDelete: Plantilla | null = null;

  ngAfterViewInit(): void {

  }
 

  ngOnInit(): void {
    //Le doy valor al botón
    const currentTranslations = plantillaTranslations[this.currentLanguage].TABLE;
    this.buttonTitle = currentTranslations.BUTTON;

    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: currentTranslations.PLANTILLAS,
        breadCrumbItems: [{ label: currentTranslations.PLANTILLAS, path: '.', active: true }]
      }
    );
    this._fetchData();

  }

  /**
 * fetches table records
 */
  _fetchData(): void {
    this.plantillasService.getPlantillas().subscribe((res) => {
      this.records = res;
      this.allDatasearch = this.records; // Guardo una copia de todos los datos para la búsqueda
      this.initTableCofig();
      this.loaded = true;
    },
      (error: string) => {
        this.error = error;
        this.loaded = false;
      });
  }

  /**
   * initialize advanced table columns
   */
  initTableCofig(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = plantillaTranslations[currentLanguage].TABLE;
    this.columns = [
      {
        name: 'nombre',
        label: currentTranslations.NAME,
        formatter: (record: Plantilla) => record.nombre,
        width: 1400,
      },
      {
        name: 'accionesPlantillas',
        label: currentTranslations.ACTIONS,
        formatter: (record: Plantilla) => null, // No es necesario enviar nada a advanced table porque la columna acciones está personalizada en el componente
        width: 200,
        sort: false
      }
    ];
  }

  // compares two cell values
  compare(v1: string | number, v2: string | number): any {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  /**
   * Sort the table data
   * @param event column name, sort direction
   */
  onSort(event: SortEvent): void {
    if (event.direction === '') {
      this.records = this.allDatasearch;
    } else {
      this.records = [...this.records].sort((a, b) => {
        const res = this.compare(a[event.column] as string | number, b[event.column] as string | number);
        return event.direction === 'asc' ? res : -res;
      });
    }
  }

  /**
* Recibe un texto y lo normaliza a lowercase y quita tildes para poder hacer búsquuedas
* @param text Texto a normalizar
*/
  normalizeText(text: string): string {
    return text.trim().toLocaleLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza letras con tilde
  }


  /**
 * Match table data with search input
 * @param row Table row
 * @param term Search the value
 */
  matches(row: Plantilla, term: string) {
    return this.normalizeText(row.nombre as string).includes(this.normalizeText(term))
      //|| this.normalizeText(row.apellidos as string).includes(this.normalizeText(term))
  }

  /**
     * Search Method
    */
  searchData(searchTerm: string): void {
    if (searchTerm === '') {
      this.records = this.allDatasearch;
    }
    else {
      let updatedData = this.allDatasearch;

      //  filter
      updatedData = updatedData.filter(record => this.matches(record, searchTerm));
      //console.log("updatedData ->",updatedData)
      this.records = updatedData;
    }

  }

  openDeleteModal(plantilla: Plantilla) {
    this.plantillaToDelete = plantilla;
    this.showConfirmDeleteModal = true;
  }

  closeDeleteModal() {
    this.showConfirmDeleteModal = false;
    this.plantillaToDelete = null;
  }

  confirmDelete() {
    if (this.plantillaToDelete?.id) {
      this.plantillasService.deletePlantilla(this.plantillaToDelete.id).subscribe(() => {
        this._fetchData();
        this.closeDeleteModal();
      });
    }
  }

}
